import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { LoadingSpinner, TooltipButton } from '../../utils/general';

const AlertModal = ({ 
    show, 
    onHide, 
    onConfirm, 
    acknowledging 
}) => {
    const [ackForSelf, setAckForSelf] = useState(true);

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            backdrop="static"
            data-bs-theme="dark"
            className="text-white"
        >
            <Modal.Header closeButton className="bg-dark" data-testid="alert-modal-header">
                <Modal.Title>Confirm Acknowledgment</Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-dark" data-testid="alert-modal-body">
                Acknowledging this alert will clear it from your list of alerts, are you sure?
            </Modal.Body>
            <Modal.Footer className="bg-dark" data-testid="alert-modal-footer">
                <Button 
                    variant="secondary" 
                    onClick={onHide}
                >
                    Cancel
                </Button>
                <Button 
                    variant="success" 
                    onClick={() => {
                        setAckForSelf(true);
                        onConfirm(true);
                    }}
                    disabled={acknowledging}
                >
                    {(acknowledging && ackForSelf) ? <>Acknowledging... <LoadingSpinner /></> : 'Yes, Ack For Myself'}
                </Button>
                <TooltipButton 
                    tooltip={<>Acknowledges alert for all groups in which you have a role of <strong>Editor</strong> or above.</>}
                    props={{
                        variant: "primary",
                        onClick: () => {
                            setAckForSelf(false);
                            onConfirm(false);
                        },
                        disabled: acknowledging
                    }}
                >
                    {(acknowledging && !ackForSelf) ? <>Acknowledging... <LoadingSpinner /></> : 'Yes, Ack For My Groups'}
                </TooltipButton>
            </Modal.Footer>
        </Modal>
    );
};

export default AlertModal; 